import React from 'react'

export default function Thanks() {
  return (
    <div>Thanks</div>
  )
}
